import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import StepConnector from '@material-ui/core/StepConnector';
// icons
import AccountBox from '@material-ui/icons/AccountBox';
import Assignment from '@material-ui/icons/Assignment';
import Home from '@material-ui/icons/Home';
import AccountBalance from '@material-ui/icons/AccountBalance';
import RateReview from '@material-ui/icons/RateReview';
import ChildFriendly from '@material-ui/icons/ChildFriendly';
import AttachFile from '@material-ui/icons/AttachFile';
import PropTypes from 'prop-types';
import clsx from 'clsx';

export const ColorlibConnector = withStyles({
  alternativeLabel: {
    top: 22,
  },
  active: {
    '& $line': {
      backgroundImage:
        'linear-gradient(90deg, rgba(20,113,181,1) 0%, rgba(45,92,166,1) 0%, rgba(16,130,213,1) 100%)',
    },
  },
  completed: {
    '& $line': {
      backgroundImage:
        'linear-gradient(90deg, rgba(20,113,181,1) 0%, rgba(121,172,61,1) 0%, rgba(89,129,43,1) 100%)',
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: '#2D5CA6',
    // backgroundColor: '#eaeaf0',
    borderRadius: 1,
  },
})(StepConnector);

export const useColorlibStepIconStyles = makeStyles({
  root: {
    backgroundColor: '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    paddingLeft: "15px",
    paddingRight: "15px",
    cursor: 'pointer'
  },
  active: {
    backgroundImage:
      'linear-gradient(90deg, rgba(20,113,181,1) 0%, rgba(45,92,166,1) 0%, rgba(16,130,213,1) 100%)',
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
  },
  completed: {
    backgroundImage:
      'linear-gradient(90deg, rgba(20,113,181,1) 0%, rgba(121,172,61,1) 0%, rgba(89,129,43,1) 100%)',
  },
  error: {
    visibility: 'hidden'
  }
});

export const customTheme = (theme) => ({
  ...theme,
  borderRadius: 0,
  minHeight: '35px !important', // squere border-radius
});

export const customStyles = {
  //это стили для селекта
  container: () => ({
    width: '100%',
    height: '35px',
    minHeight: '35px',
  }),
  control: (base) => ({
    ...base,
    height: '35px',
    minHeight: '35px',
    //border: "1px solid red"
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  input: () => ({
    height: '35px',
    minHeight: '35px',
    paddingBootom: '10px',
  }),
  valueContainer: (base) => ({
    ...base,
    container: () => ({
      width: '100%',
    }),
  }),

  indicatorsContainer: (base) => ({
    ...base,
    height: '35px',
    minHeight: '35px',
  }),
  menu: () => ({
    width: '100%',
    backgroundColor: '#fff',
    zIndex: 444,
    border: '1px solid #C2C5CB',
  }),

  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
  }), //- resolve problem with zindex of options
};

export const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  button: {
    marginRight: theme.spacing(1),
  },
//   instructions: {
//     marginTop: theme.spacing(1),
//     marginBottom: theme.spacing(1),
//   },
}));

export function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed, error } = props;

  const icons = {
    'Персональні дані': <AccountBox />,
    'Паспортні дані': <Assignment />,
    'Адреса': <Home />,
    'Банківські реквізити': <AccountBalance />,
    'Діти': <ChildFriendly />,
    'Документи': <AttachFile />,
    'Перегляд заповнених даних': <RateReview />,
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
        [classes.error]: error
      })}
    >
      {icons[String(props.icon)]}
    </div>
  );
}

ColorlibStepIcon.propTypes = {
  active: PropTypes.bool,
  completed: PropTypes.bool,
  icon: PropTypes.node,
};
